import { useState, useCallback } from 'react';

/**
 * Custom hook that works like useState but persists data to localStorage
 * @param {string} key - The localStorage key to store the value under
 * @param {*} defaultValue - The default value to use if no value exists in localStorage
 * @returns {[*, function]} - Returns [value, setValue] tuple like useState
 */
export const useStorage = (key, defaultValue) => {

  const [value, setValue] = useState(() => {
    return localStorage.getItem(key) !== null ? JSON.parse(localStorage.getItem(key)) : undefined
  });

  const return_value = value !== undefined ? value : defaultValue;

  const updateValue = useCallback((new_value) => {
    setValue(new_value);
    localStorage.setItem(key, JSON.stringify(new_value));
  }, [key]);

  return [return_value, updateValue];
}
